import { IconButton } from "@mui/material";
import Iconify from "src/components/Iconify";

export default function Options() {
	return (
		<IconButton sx={{ p: 0.5 }}>
			<Iconify icon={"mdi:edit"} width={16} />
		</IconButton>
	);
}
